import React from 'react';
import ProjectOrdersListContainer from '../../containers/project_orders/ProjectOrdersListContainer';

const ProjectOrdersListPage = () => {
  return <ProjectOrdersListContainer />;
};

export default ProjectOrdersListPage;
